import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import '@fontsource-variable/plus-jakarta-sans';
import App from './App';
import './styles/main.css';

registerSW({
  onNeedRefresh() {
    window.dispatchEvent(new CustomEvent('senoskripsi:update-ready'));
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
